const formsortEnvironmentLookup: Record<string, string | undefined> = {
  production: undefined,
  staging: 'staging',
  development: 'development-dev-purposemed',
};

const publicSiteLookup: Record<string, string> = {
  production: 'https://www.gofreddie.com',
  // eslint-disable-next-line @pm/architecture/no-brand-logic
  staging: 'https://freddie-beta.webflow.io',
  // eslint-disable-next-line @pm/architecture/no-brand-logic
  development: 'https://freddie-beta.webflow.io',
};

const apiLookup: Record<string, () => string | undefined> = {
  production: () => 'https://api.gofreddie.com',
  staging: () => 'https://api-staging.gofreddie.com',
  development: () => import.meta.env.VITE_API_HOST,
};

export const formsortEnvFromEnv = () => {
  // if environment is undefined infer we are in development, since our
  // .env file has not been setting VITE_ENVIRONMENT historically
  const environment = import.meta.env.VITE_ENVIRONMENT || 'development';

  return formsortEnvironmentLookup[environment];
};

export const publicSiteUrlFromEnv = () => {
  const environment = import.meta.env.VITE_ENVIRONMENT || 'development';

  return publicSiteLookup[environment];
};

export const apiUrlFromEnv = () => {
  const environment = import.meta.env.VITE_ENVIRONMENT || 'development';

  return apiLookup[environment]?.();
};

export const currentAppUrl = () => {
  const hostname = window.location.hostname;
  return `https://${hostname}`;
};
